import React from "react";
import { connect } from 'react-redux';

import { onChangeDefaultSelection, onValueChange, recalculatePaymentFee, selectCustomAmount } from "../reducer";

import get from 'lodash.get';
import debounce from 'lodash/debounce';
import createNumberMask from "text-mask-addons/dist/createNumberMask";

import { Form, Image } from "semantic-ui-react";
import MaskedColoredInputField from "../components/coloredMaskedInputField";
import CondensedLabeledSelect from "../components/condencedLabeledSelect";
import CondensedLabeledButton from "../components/condensedLabeledButton";
import DonateTypeSelect from "../payment/donateTypeSelect";

import { getSmallHeroImage } from "../../../helpers/imageHelper";
import * as validationHelper from "../../../helpers/validationHelper";

import { AMOUNT_VALIDATION, paths } from "../constants/index";

class AmountTabContainer extends React.Component {
    componentDidUpdate() {
        const isAmountValid = validationHelper.isValid(AMOUNT_VALIDATION, this.props.amount);

        if (this.props.isTabValid !== isAmountValid) {
            this.props.onValueChange(paths.IS_AMOUNT_TAB_VALID, isAmountValid);
        }
    }

    componentDidMount = () => {
        if (!this.props.campaign.defaultDonations || !this.props.campaign.defaultDonations.some(x => x)) {
            this.props.selectCustomAmount();
        }
        window.scrollTo(0, 0)
    }

    onValueChange = value => {
        this.props.onValueChange("amount", value);
        this.props.onValueChange("paymentRequestAmount", value);
        this.recalculateFee(value);
    }

    recalculateFee = debounce((value) => {
        if (this.props.recalculateFeeOnAmountChange) {
            this.props.recalculatePaymentFee(this.props.primaryPath, this.props.campaign.urlPath, value, this.props.coverProcessingFee);
        }
    }, 500);

    onSelectionClick = (index, amount, description) => {
        if (index !== this.props.selectedDefaultAmountIndex) {
            this.props.onSelectionClick(index, amount, description);

            if (this.props.recalculateFeeOnAmountChange) {
                this.props.recalculatePaymentFee(this.props.primaryPath, this.props.campaign.urlPath, amount, this.props.coverProcessingFee);
            }
        }
    }

    onCustomAmountSelect = () => {
        this.props.selectCustomAmount();
    }

    getSelectedAmount = () => {
        if (!this.props.customAmountSelected && this.props.selectedDefaultAmountIndex) {
            const index = this.props.selectedDefaultAmountIndex - 1;
            const selectedAmount = get(this.props, `campaign.defaultDonations.${index}`);
            return selectedAmount;
        }
        return null;
    }

    render() {
        const { campaign, defaultAmounts } = this.props;
        const showContent = defaultAmounts && !defaultAmounts.some(item => !item.description);
        const showImage = defaultAmounts && !defaultAmounts.some(item => !item.image);

        const numberMask = createNumberMask({
            prefix: "",
            allowDecimal: true,
            includeThousandsSeparator: false
        });
        const selectedAmount = this.getSelectedAmount();

        const hideOtherAmount = get(campaign, 'original.template.value.donationSetup.hideOtherAmount');

        return (
            <React.Fragment>
                <DonateTypeSelect />
                <div className={"default-amount-container custom"}>
                    <CondensedLabeledSelect>
                        {
                            defaultAmounts && defaultAmounts.map((item, index) => (
                                <CondensedLabeledButton
                                    key={index + 1}
                                    id={index + 1}
                                    label={`$${item.amount}`}
                                    amount={item.amount}
                                    buttonTextColor="#fff"
                                    colored={(index + 1) === this.props.selectedDefaultAmountIndex}
                                    onClick={() => this.onSelectionClick(index + 1, item.amount, item.description)} />
                            ))
                        }
                        {
                            !hideOtherAmount &&
                            <CondensedLabeledButton
                                label="Other"
                                colored={this.props.customAmountSelected}
                                buttonTextColor="#fff"
                                onClick={this.onCustomAmountSelect}
                            />
                        }
                    </CondensedLabeledSelect>
                    {
                        selectedAmount && (showImage || showContent) &&
                        <div className="default-amount-item-holder">
                            {
                                selectedAmount && showImage &&
                                <Image className="default-amount-item-image" src={getSmallHeroImage(selectedAmount.image)} />
                            }
                            {
                                selectedAmount && showContent &&
                                <div className="default-amount-item-description">
                                    {selectedAmount.description}
                                </div>
                            }
                        </div>
                    }
                    {
                        !hideOtherAmount &&
                        this.props.customAmountSelected &&
                        <Form className="other-amount">
                            <Form.Field>
                                <label>Other amount</label>
                                <MaskedColoredInputField onChange={this.onValueChange}
                                    value={this.props.amount}
                                    validation={AMOUNT_VALIDATION}
                                    mask={numberMask}
                                />
                            </Form.Field>
                        </Form>
                    }
                </div>
            </React.Fragment>
        );
    }
}

const mapState = state => {
    return {
        campaign: get(state, 'page.campaign'),
        defaultAmounts: get(state, 'donation.defaultAmounts'),
        selectedDefaultAmountIndex: get(state, 'donation.selectedDefaultAmountIndex'),
        customAmountSelected: get(state, 'donation.customAmountSelected'),
        amount: get(state, 'donation.amount'),
        isTabValid: get(state, 'donation.tabsValidation[tabs.AMOUNT]'),
        coverProcessingFee: get(state, 'donation.coverProcessingFee'),
        primaryPath: get(state, 'page.primaryPath')
    }
}

const mapDispatch = (dispatch) => {
    return {
        onSelectionClick(index, amount, donationText) {
            dispatch(onChangeDefaultSelection(index, amount, donationText));
        },
        onValueChange(path, value) {
            dispatch(onValueChange(path, value));
        },
        selectCustomAmount() {
            dispatch(selectCustomAmount());
        },
        recalculatePaymentFee(primaryPath, campaignPath, amount, coverFee) {
            dispatch(recalculatePaymentFee(primaryPath, campaignPath, amount, coverFee))
        }
    }
}

const AmountTab = connect(mapState, mapDispatch)(AmountTabContainer);
export default AmountTab;
